
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explorer/graphql",
      function () {
        return require("private-next-pages/explorer/graphql.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explorer/graphql"])
      });
    }
  